/*
  AMUMIN wachtlijst: venster openen en sluiten, focus binnen het venster houden, Escape sluit,
  formulier versturen zonder de pagina te verlaten (met terugval op gewoon versturen),
  en na een gewone verzending (?customer_posted=true#<formulier-id>) het venster met de juiste stand tonen.
  Opslag gebeurt door Shopify zelf (klantformulier). Geen externe diensten.
*/
(function () {
  if (window.__amuminWaitlist) return;
  window.__amuminWaitlist = true;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function Waitlist(dialog) {
    this.dialog = dialog;
    this.formId = dialog.getAttribute('data-form-id');
    this.form = document.getElementById(this.formId);
    this.viewForm = dialog.querySelector('[data-am-waitlist-view="form"]');
    this.viewSuccess = dialog.querySelector('[data-am-waitlist-view="success"]');
    this.errorBox = dialog.querySelector('[data-am-waitlist-error]');
    this.submit = dialog.querySelector('.am-waitlist__submit');
    this.opener = null;
    this.bind();
  }

  Waitlist.prototype.bind = function () {
    var self = this;
    var dialog = this.dialog;

    Array.prototype.forEach.call(dialog.querySelectorAll('[data-am-waitlist-close]'), function (btn) {
      btn.addEventListener('click', function () {
        self.close();
      });
    });

    // Klik op de achtergrond sluit.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) self.close();
    });

    // Escape (native "cancel") en focusval.
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      self.close();
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        self.close();
        return;
      }
      if (event.key !== 'Tab') return;
      var items = Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (this.form) {
      this.form.addEventListener('submit', function (event) {
        self.onSubmit(event);
      });
    }
  };

  Waitlist.prototype.open = function (opener) {
    this.opener = opener || document.activeElement;
    var dialog = this.dialog;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('am-waitlist-open');
    var target = this.viewSuccess && !this.viewSuccess.hidden
      ? this.dialog.querySelector('[data-am-waitlist-success-title]')
      : this.dialog.querySelector('input:not([type="hidden"])');
    if (target) {
      window.setTimeout(function () {
        target.focus();
      }, 30);
    }
  };

  Waitlist.prototype.close = function () {
    var dialog = this.dialog;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    document.documentElement.classList.remove('am-waitlist-open');
    if (this.opener && typeof this.opener.focus === 'function') this.opener.focus();
    // Na een gelukte aanmelding: de URL weer schoon, zodat herladen niet opnieuw opent.
    if (window.location.hash === '#' + this.formId && window.history && window.history.replaceState) {
      var url = window.location.pathname + window.location.search.replace(/([?&])customer_posted=true&?/, '$1').replace(/[?&]$/, '');
      window.history.replaceState(null, '', url);
    }
  };

  Waitlist.prototype.showError = function (type) {
    if (!this.errorBox) return;
    Array.prototype.forEach.call(this.errorBox.querySelectorAll('[data-error]'), function (p) {
      p.hidden = p.getAttribute('data-error') !== type;
    });
    this.errorBox.hidden = !type;
  };

  Waitlist.prototype.showSuccess = function () {
    this.showError('');
    if (this.viewForm) this.viewForm.hidden = true;
    if (this.viewSuccess) this.viewSuccess.hidden = false;
    var title = this.dialog.querySelector('[data-am-waitlist-success-title]');
    if (title) title.focus();
  };

  Waitlist.prototype.setBusy = function (busy) {
    if (!this.submit) return;
    if (busy) {
      this.submit.setAttribute('data-label', this.submit.textContent);
      this.submit.textContent = this.submit.getAttribute('data-label-sending') || this.submit.textContent;
      this.submit.disabled = true;
    } else {
      if (this.submit.getAttribute('data-label')) this.submit.textContent = this.submit.getAttribute('data-label');
      this.submit.disabled = false;
    }
  };

  // Vult de velden die Shopify opslaat: naam, notitie (telefoon, gezinsgrootte, taal) en tags.
  Waitlist.prototype.prepare = function () {
    var f = this.form;
    var name = (f.elements.waitlist_name.value || '').trim().replace(/\s+/g, ' ');
    var phone = (f.elements.waitlist_phone.value || '').trim();
    var household = f.elements.waitlist_household.value || '';
    var parts = name.split(' ');
    f.elements['contact[first_name]'].value = parts.shift() || '';
    f.elements['contact[last_name]'].value = parts.join(' ');

    var tagInput = f.elements['contact[tags]'];
    var tags = tagInput.getAttribute('data-base-tags') || tagInput.value;
    if (household) tags += ',wachtlijst-gezin-' + household.replace('+', 'plus');
    tagInput.value = tags;

    var lang = document.documentElement.getAttribute('lang') || '';
    var note = ['Wachtlijst AMUMIN-app', 'Naam: ' + name];
    if (phone) note.push('Telefoon: ' + phone);
    if (household) note.push('Gezinsleden: ' + household);
    if (lang) note.push('Taal: ' + lang);
    note.push('Toestemming: ja (' + new Date().toISOString().slice(0, 10) + ')');
    f.elements['contact[note]'].value = note.join(' | ');

    var consent = f.elements.waitlist_consent;
    var marketing = f.querySelector('input[name="contact[accepts_marketing]"]');
    if (consent.checked && !marketing) {
      marketing = document.createElement('input');
      marketing.type = 'hidden';
      marketing.name = 'contact[accepts_marketing]';
      marketing.value = 'true';
      f.appendChild(marketing);
    } else if (!consent.checked && marketing) {
      marketing.parentNode.removeChild(marketing);
    }
  };

  Waitlist.prototype.valid = function () {
    var f = this.form;
    var nameOk = (f.elements.waitlist_name.value || '').trim().length > 0;
    var emailEl = f.elements['contact[email]'];
    var emailOk = emailEl.value.trim().length > 0 && (typeof emailEl.checkValidity !== 'function' || emailEl.checkValidity());
    var consentOk = f.elements.waitlist_consent.checked;
    [[f.elements.waitlist_name, nameOk], [emailEl, emailOk], [f.elements.waitlist_consent, consentOk]].forEach(function (pair) {
      if (pair[1]) pair[0].removeAttribute('aria-invalid');
      else pair[0].setAttribute('aria-invalid', 'true');
    });
    if (!nameOk) f.elements.waitlist_name.focus();
    else if (!emailOk) emailEl.focus();
    else if (!consentOk) f.elements.waitlist_consent.focus();
    return nameOk && emailOk && consentOk;
  };

  Waitlist.prototype.onSubmit = function (event) {
    var self = this;
    var f = this.form;
    if (!this.valid()) {
      event.preventDefault();
      this.showError('required');
      return;
    }
    this.prepare();
    if (!window.fetch || !window.FormData || !window.DOMParser) return; // gewoon versturen

    event.preventDefault();
    this.showError('');
    this.setBusy(true);
    var nativeSubmit = function () {
      self.setBusy(false);
      HTMLFormElement.prototype.submit.call(f);
    };

    fetch(f.action, {
      method: 'POST',
      body: new FormData(f),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    })
      .then(function (response) {
        var url = response.url || '';
        // Shopify vraagt soms een controle (captcha): dan gewoon versturen, de pagina toont die.
        if (url.indexOf('/challenge') !== -1) {
          nativeSubmit();
          return null;
        }
        if (url.indexOf('customer_posted=true') !== -1) {
          self.setBusy(false);
          self.showSuccess();
          return null;
        }
        return response.text().then(function (html) {
          self.setBusy(false);
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var view = doc.querySelector('#' + self.formId + ' [data-am-waitlist-view="form"]');
          var state = view ? view.getAttribute('data-server-state') : '';
          if (state === 'success') {
            self.showSuccess();
          } else if (state === 'error') {
            self.showError(view.getAttribute('data-server-error') === 'exists' ? 'exists' : 'generic');
          } else {
            nativeSubmit();
          }
        });
      })
      .catch(function () {
        nativeSubmit();
      });
  };

  // Na een gewone verzending staat het formulier-id in de URL: venster direct tonen in de juiste stand.
  Waitlist.prototype.restore = function () {
    var view = this.viewForm;
    var serverState = view ? view.getAttribute('data-server-state') : 'form';
    var ownHash = window.location.hash === '#' + this.formId;
    if (!ownHash) {
      // Een ander klantformulier (bijv. nieuwsbrief in de voettekst) is verstuurd: hier niets tonen.
      if (serverState !== 'form') this.showError('');
      return;
    }
    var posted = /[?&]customer_posted=true/.test(window.location.search);
    if (posted || serverState === 'success') {
      this.showSuccess();
    } else if (serverState === 'error') {
      this.showError(view.getAttribute('data-server-error') === 'exists' ? 'exists' : 'generic');
    }
    var opener = document.querySelector('.am-app [data-am-waitlist-open="' + this.dialog.id + '"]') || document.querySelector('[data-am-waitlist-open="' + this.dialog.id + '"]');
    if (opener && opener.scrollIntoView) opener.scrollIntoView({ block: 'center' });
    this.open(opener);
    if (posted || serverState === 'success') this.showSuccess();
  };

  // Eén klikluisteraar voor alle openers (app-sectie, app-menu op desktop en mobiel).
  document.addEventListener('click', function (event) {
    var opener = event.target.closest ? event.target.closest('[data-am-waitlist-open]') : null;
    if (!opener) return;
    var dialog = document.getElementById(opener.getAttribute('data-am-waitlist-open'));
    if (!dialog || !dialog.__amWaitlist) return;
    event.preventDefault();
    // Vanuit het mobiele menu: eerst het menu sluiten.
    var drawer = opener.closest('header-drawer');
    if (drawer && typeof drawer.closeMenuDrawer === 'function') {
      // HeaderDrawer sluit alleen met een element om de focus op terug te zetten.
      drawer.closeMenuDrawer(event, drawer.querySelector('summary'));
    }
    dialog.__amWaitlist.open(opener);
  });

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-am-waitlist]'), function (dialog) {
      if (dialog.__amWaitlist) return;
      dialog.__amWaitlist = new Waitlist(dialog);
      dialog.__amWaitlist.restore();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
